import React, { useState } from 'react'
import {
  PanelCollapsible,
  Group,
  SearchForm,
  Item,
  SpacingVertical,
  SPACING_24,
  DataTable
} from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { InputSearchString } from './InputSearchString'
import { pageDataState } from 'Pages/SmsQueue/recoil/states/state'
import { useRecoilValue } from 'recoil'

export const Costs = () => {
  const intl = useIntl()

  const { Items } = useRecoilValue(pageDataState)

  const [check, setCheck] = useState(false)

  const handleOnChangeToggle = () => {
    setCheck(!check)
  }
  const [searchText, setSearchParams] = useState('')
  const [rows, setRows] = useState(Items)

  const handleInputChange = e => {
    const val = e.target.value
    setSearchParams(val)
  }

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const handleSubmit = e => {
    if (searchText) {
      const newRows = Items.filter(
        e => e.Country.toLowerCase().indexOf(searchText.toLowerCase()) > -1
      )

      if (newRows.length === 0) {
        const otherDestinationsRow = Items.filter(
          e => e.Country.toLowerCase().indexOf('other destinations') > -1
        )
        setRows(otherDestinationsRow)
      } else {
        setRows(newRows)
      }
    }
  }

  const handleReset = e => {
    setRows(Items)
    setSearchParams('')
  }

  return (
    <PanelCollapsible
      title={intl.formatMessage({ id: 'Load.QueueSms.TableCosts' })}
      collapsed={!check}
      onChange={handleOnChangeToggle}
    >
      <SpacingVertical variant={SPACING_24} />
      <SearchForm
        advanced={false}
        labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
        labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
        onClickToggle={() => {}}
        onClickReset={handleReset}
        onSubmit={handleSubmit}
        expanded={false}
      >
        <Group>
          <Item>
            <InputSearchString
              handleKeyPress={handleKeyPress}
              handleInputChange={handleInputChange}
              searchText={searchText}
            />
          </Item>
        </Group>
      </SearchForm>
      <SpacingVertical variant={SPACING_24} />

      <DataTable
        sortable={false}
        head={[
          {
            span: 5,
            content: intl.formatMessage({
              id: 'Load.MailupCommon.MemberState'
            }),
            sortable: false
          },
          {
            span: 3,
            content: intl.formatMessage({ id: 'Load.queue_SMS.htUnitCost' }),
            sortable: false
          },
          {
            span: 4,
            content: intl.formatMessage({
              id: 'Load.QueueSms.htAvailableSend'
            }),
            sortable: false
          }
        ]}
        body={rows.map(e => [
          { content: e.Country },
          { content: e.UnitCost },
          { content: e.AvailableSend }
        ])}
      />
      <SpacingVertical />
    </PanelCollapsible>
  )
}
export default Costs
